/* tslint:disable:jsx-no-lambda */

import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { ColumnDefinition, Table } from '@abb/common-ux';

export class ProfileComponent extends React.Component<any, any> {
  render() {
    const KeyValueRow = ColumnDefinition as new () => ColumnDefinition<IKeyValue>;
    const { profile } = this.props.loggedInUser;

    const userProfile = Object.keys(profile).sort().map((claim) => {
      return { name: claim, value: profile[claim] };
    });

    return (
      <div>
        <h3>Claims from id token</h3>
        <Table data={userProfile}>
          <KeyValueRow cell={(row) => row.name} header='Claim' />
          <KeyValueRow cell={(row) => row.value} header='Value' />
        </Table>
      </div>);
  }
}
export default withRouter(connect(mapStateToProps)(ProfileComponent) as any);

function mapStateToProps(store: any) {
  return {
    loggedInUser: store.userState.loggedInUser
  };
}

interface IKeyValue {
  name: string;
  value: string;
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/modules/authentication/components/Profile.tsx